// extracted by mini-css-extract-plugin
export default {"container":"Card_container__DbXh1","img":"Card_img__8Ehvv","textBox":"Card_textBox__PagiU","name":"Card_name__Qjf9y","continent":"Card_continent__Lnmzp"};